/* import __COLOCATED_TEMPLATE__ from './conversation-screen.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();